module.exports={account_link_complete_message:"A conta Nexon foi vinculada."};